


























































import { Component, Mixins } from 'vue-property-decorator';
import Testimonials from '@rogues/Testimonials/shared/testimonials';

@Component
/**
 * @name Slider
 */
export default class Slider extends Mixins(Testimonials) {}
